module.exports = __webpack_public_path__ + "static/media/Mousse & Cream Stabilizers.aff37928.jpg";